import { useMemo } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { useRoomContext } from '@src/contexts';
import { useQuestionAndAnswerStore } from '@src/stores';

import { IQuestionAnswer, IQuestionAssignee } from '@src/types';

interface IProps {
  answer: IQuestionAnswer;
  author: IQuestionAssignee;
}

const useQuestionReply = ({ answer: currentAnswer, author }: IProps) => {
  const { currentPeer } = useRoomContext();

  const { setIsAnswerBoxOpened, setAnswerToEdit } = useQuestionAndAnswerStore(
    useShallow((state) => ({
      setIsAnswerBoxOpened: state.setIsAnswerBoxOpened,
      setAnswerToEdit: state.setAnswerToEdit,
    }))
  );

  const replyMenuItems = useMemo(
    () => [
      {
        label: 'Edit',
        onClick: () => {
          setAnswerToEdit(currentAnswer);
          setIsAnswerBoxOpened(true);
        },
      },
    ],
    [currentAnswer, setAnswerToEdit, setIsAnswerBoxOpened]
  );

  const isEditable = useMemo(
    () => author.recordId === currentPeer?.record_id,
    [author.recordId, currentPeer?.record_id]
  );

  return {
    isEditable,
    replyMenuItems,
  };
};

export default useQuestionReply;
